<app-form
  [title]="'Datos del demandante persona jurídica'"
  [fields]="formFields"
  (submitAction)="onSubmit($event)"
  (changeAction)="onChanges($event)"
  [withSubmitButton]="withSubmitButton"></app-form>
